import FormPage from '@/components/FormPage'
import security from '@/security'
import { createGetParams, createPostParams } from '@/rest'

const formTitle = 'Reactivation Subscription'
const defaultPin = 'D500'

export default {
  extends: FormPage,
  data () {
    return {
      name: null,
      street1: null,
      street2: null,
      city: null,
      postalCode: null,
      state: null,
      quantity: 1,
      breadcrumbs: [
        {
          text: 'Dealer Kits', disabled: false, to: '/dealer_kits',
        },
        {
          text: 'Dealership', disabled: false, to: '/dealership_kits',
        },
        {
          text: formTitle, disabled: true,
        },
      ],
      title: formTitle,
      // Form steps
      transferDetails: {
        fields: {
          d500Pin: {
            name: defaultPin + ' balance',
          },
          dealer: {
            component: () => import(/* webpackChunkName: "dealerSubscription" */ '@/components/DealerSubscription'),
            name: 'To dealer Id',
            props: {
              persistentHint: true,
              label: 'Enter Dealer Id',
              noSelf: true,
              claimer: security.me.claimer(),
              required: true,
              rules: [val => !!val || 'Dealer Id required!'],
            },
          },
        },
        title: 'Dealer subscription details',
      },
      submission: {
        fields: {
          dealer: {
            name: 'To dealer Id',
          },
          dealerStatus: {
            name: 'Dealer status',
          },
          demotedMonth: {
            name: 'Demoted Month',
            hide: true,
          },
        },
        submit: false,
        errorMessage: null,
        status: null,
        subTitle: 'Check before submit',
        title: 'Submit',
      },
    }
  },
  computed: {
    formSteps: function () {
      return {
        transferDetails: this.transferDetails,
        submission: this.submission,
      }
    },
  },
  mounted: function () {
    const params = createGetParams({
      dealership_pin: true,
    })
    this.$rest.get('getDealerResources.php', params).then(response => {
      if (security.me.pureNuDealer()) {
        this.transferDetails.fields.nuPin.value = response.data.nuPin
        this.transferDetails.fields.bPin = {}
        this.transferDetails.fields.sdPin = {}
        this.transferDetails.fields.dealerPin = {}
        this.transferDetails.fields.d225Pin = {}
        this.transferDetails.fields.dpPin = {}
        this.transferDetails.fields.d500Pin = {}
      } else {
        this.transferDetails.fields.d500Pin.value = response.data.d500Pin ? response.data.d500Pin : 0
      }
    })
    this.validateD500Pin()
  },
  watch: {
    'transferDetails.fields.dealer.value': function (val) {
      this.submission.fields.dealer.value = val

      if (val) {
        const params = createGetParams({
          target: val,
        })

        this.$rest.get('getDealerSubscription.php', params)
          .then(response => {
            const status = response.data.status

            this.submission.fields.dealerStatus.value = status
            this.submission.fields.demotedMonth.value = response.data.demoteMonth

            // ✅ show only if Demoted
            this.submission.fields.demotedMonth.hide = status !== 'Demoted'
          })
          .catch(() => {
          // ignore
          })
      }
    },
  },

  methods: {
    validateD500Pin: function () {
      return this.d500Pin <= 0 ? 'Insufficient ' + defaultPin + ' PIN!' : true
    },
    // Override
    async submit () {
      const params = createPostParams({
        action: 'reactivateSubscription',
        payload: {
          type: 'D500',
          target: this.transferDetails.fields.dealer.value,
          quantity: '1',
        },
      })

      try {
        const response = await this.$rest.post('postAction.php', params)
        this.$nextTick(() => {
          this.alertText = 'Your request to reactivate dealership was successfully submitted.'
          this.status = this.submission.status = 'success'
          this.submission.submit = false
          this.isImpersonated() && this.showSubmissionResponse(response.data)
        })
      } catch (e) {
        this.$nextTick(() => {
          this.status = this.submission.status = 'error'
          this.submission.errorMessage = e.message + ': ' + e.response.data
          this.submission.submit = false
        })
      }
    },
  },
}
